import { render, staticRenderFns } from "./NuevoLegajo.vue?vue&type=template&id=63e615c0&"
import script from "./NuevoLegajo.vue?vue&type=script&lang=js&"
export * from "./NuevoLegajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports